import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    rootItemListProgramCardDetail: {
        width: '100%',
        background: theme.palette.colors.fillStroke[400],
    },
    dataContainer: {
        padding: "16px",
    },
    priceAndMembershipContainer: {
        height: "32px",
    },
    icon: {
        fontSize: "16px",
        marginRight: "6px",
        color: theme.palette.colors.gray[100],
    },
    text: {
        color: theme.palette.colors.gray[100],
    },
    introductionTitle: {
        marginTop: "16px",
    },
    introductionText: {
        marginTop: "8px",
        '-webkit-line-clamp': 6,
        '-webkit-box-orient': 'vertical',
        display: '-webkit-box',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        overflowWrap: 'break-word',
    },
    buttonContainer: {
        marginTop: "16px",
    },
    saveProgramButton: {
        width: "40px !important",
        height: "40px !important",
    },
    readMoreButton: {
        padding: 0,
    },
    buttonGoToProgramDetail: {
        width: "100%",
    },
    priceAndMembershipTopBorder: {
        borderTop: `1px solid ${theme.palette.colors.fillStroke[200]} !important`,
    },
}));